<template>
    <CompassDialog
        :visible.sync="showModal"
        size="small"
        :title="$t.__('documents.overview.menu.ValidationPopup.finalising_your_document')"
        class="validation-popup"
        @closed="$emit('update:show', false)"
    >
        <template slot="default">
            <div class="dialog__default">
                <div v-if="edit === false">
                    <p v-if="doctype == 'invoice'">
                        {{ $l10n.__('Cette action va transformer votre brouillon en facture') }}
                        <br />
                        <br />
                        {{
                            $l10n.__(
                                'Cette action est définitive, vous ne pourrez plus choisir le statut brouillon par la suite. Votre facture prendra un numéro officiel et sera comptabilisée dans votre chiffre d’affaires.',
                            )
                        }}
                    </p>
                    <p v-if="doctype == 'creditnote'">
                        {{ $l10n.__('Cette action va transformer votre brouillon en avoir') }}
                        <br />
                        <br />
                        {{
                            $l10n.__(
                                'Cette action est définitive, vous ne pourrez plus choisir le statut brouillon par la suite. Votre avoir prendra un numéro officiel et sera comptabilisée dans votre chiffre d’affaires.',
                            )
                        }}
                    </p>

                    <div class="mt-3 acenter">
                        <span v-if="doctype == 'invoice'">
                            {{ $l10n.__('Votre facture sera datée du') }}
                        </span>
                        <span v-if="doctype == 'creditnote'">
                            {{ $l10n.__('Votre avoir sera daté du') }}
                        </span>

                        <strong class="fs-4 mt-1 block">
                            {{ validateDate }}
                        </strong>
                        <span class="link fs-2 mt-2 block" @click="edit = true">
                            {{ $l10n.__('Modifier la date de facturation') }}
                        </span>
                    </div>
                </div>

                <div v-else>
                    <p>
                        {{
                            $l10n.__(
                                'La date de facturation devrait suivre l’ordre chronologique des numéros de facturation.',
                            )
                        }}
                    </p>

                    <div class="mt-4 acenter">
                        {{ $l10n.__('Selectionnez une date de facturation') }}
                        <el-date-picker
                            v-model="date"
                            :clearable="false"
                            :format="datePickerFormat"
                            :pickerOptions="pickerOptions"
                            type="date"
                        />
                        <span class="link fs-2 mt-2 block" @click="date = initDate">
                            {{ $l10n.__('Réinitialiser la date') }}
                        </span>
                    </div>
                </div>
            </div>
        </template>
        <template slot="footer">
            <div class="dialog__footer">
                <CompassButton
                    :label="$t.__('common.actions.cancel')"
                    type="secondary"
                    @click="$emit('update:show', false)"
                />
                <CompassButton
                    v-if="edit"
                    :label="$t.__('common.actions.save')"
                    type="primary"
                    @click="edit = false"
                />
                <CompassButton
                    v-else
                    :label="action"
                    type="primary"
                    :loading="loading"
                    class="ml-3"
                    @click="finish"
                />
            </div>
        </template>
    </CompassDialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapGetters } = createNamespacedHelpers('corp');
const { mapActions, mapState } = createNamespacedHelpers('documentOverview');

export default {
    props: {
        show: {
            type: String,
            required: true,
        },
        canUpdateDate: {
            type: Boolean,
            require: true,
        },
        lastValidationDate: {
            type: String,
            required: true,
        },
        initDate: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            showModal: true,
            loading: false,
            safeDate: this.initDate,
            edit: false,
            emailAfterValidation: false,
        };
    },
    computed: {
        date: {
            get() {
                return this.safeDate;
            },
            set(value) {
                this.safeDate = value === null ? this.initDate : value;
            },
        },
        visible: function () {
            return this.show ? true : false;
        },
        validateDate: function () {
            return this.date === null
                ? this.$l10n.__('Date invalide')
                : moment(this.date).format('LL');
        },
        title: function () {
            return this.edit
                ? this.$l10n.__('Modification de la date de facturation')
                : this.$l10n.__('Finalisation de votre document');
        },
        action: function () {
            switch (this.show) {
                case 'email':
                case 'postal':
                    return this.$l10n.__('Finaliser et envoyer');
                case 'validation':
                default:
                    return this.$l10n.__('Finaliser');
            }
        },
        pickerOptions() {
            if (!this.canUpdateDate) {
                return {
                    disabledDate: (time) => {
                        return (
                            time.getTime() > Date.now() ||
                            time.getTime() < Date.parse(this.lastValidationDate)
                        );
                    },
                };
            }
            return;
        },
        ...mapGetters(['datePickerFormat']),
        ...mapState(['doclabel', 'doctype']),
    },
    methods: {
        finish: function () {
            this.loading = true;
            this.validate({ date: moment(this.date).format('YYYY-MM-DD') }).then(
                (success) => {
                    if (this.show != 'validation') {
                        let current = window.location.search;
                        let regex = new RegExp('([?;&])afterRecording[^&;]*[;&]?');
                        let query = current.replace(regex, '$1').replace(/&$/, '');
                        window.location.search =
                            (query.length > 2 ? query + '&' : '?') +
                            (this.show ? 'afterRecording=' + this.show : '');
                    } else {
                        location.reload(true);
                    }
                },
                (failure) => {
                    Push.error(this.$l10n.__('Problème avec la date'));
                    this.loading = false;
                },
            );
        },
        ...mapActions(['validate']),
    },
};
</script>
<style lang="scss" scoped>
.validation-popup {
    &__default {
        padding-bottom: 24px;
    }

    &__footer {
        display: flex;
        justify-content: flex-end;
        padding: 0 32px 24px 32px;
    }
}
</style>
